<div class="headermaster">

  <nav class="navbar titlebar" style="align-items: center; justify-content: flex-start;">
    <!-- Brand/logo -->
    <img src="assets/images/logo.png" width="70" />
    <!-- Links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <div class="contentheader">สถาบันคุ้มครองเงินฝาก</div>
        <div class="contentheader2">Deposit Protection Agency</div>
      </li>
    </ul>
    <ul class="nav navbar-nav navbar-right ml-auto">
      <li class="nav-item titlebar">
        <button id="btnLogOut" class="btn btn-logout" (click)="Logout()">
          <label class="lbl-logout">ออกจากระบบ</label>
          <i class="fa fa-sign-out-alt"></i>
        </button>
      </li>
    </ul>
  </nav>
</div>

<div class="wrappermaster">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="menu-tab">
        <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
          <div class="col-md-8 col-sm-4 pl-0 pr-0">
          </div>
          <li class="nav-item col-md-2 col-sm-4 pl-0 pr-0" id="MenuTicketList">
            <a class="nav-link user-menu bd-left-none" id="ticketlist" data-toggle="tab" href="" role="tab" aria-selected="false">
              <span class="fa fa-2x fa-tasks"></span>
              <span class="badge badge-pill badge-danger"></span>
              <br>
              Ticket List
            </a>
          </li>
          <li class="nav-item col-md-2 col-sm-4 pl-0 pr-0" id="MenuReqDocument">
            <a class="nav-link user-menu bd-left-none" id="prereqdocument" data-toggle="tab" href="" role="tab"
              aria-selected="false">
              <span class="fa fa-2x fa-book"></span>
              <span class="badge badge-pill badge-danger"></span>
              <br>
              ขอเอกสาร
            </a>
          </li>
          <li class="nav-item col-md-2 col-sm-4 pl-0 pr-0" id="MenuRegister">
            <a class="nav-link user-menu bd-left-none" id="register" data-toggle="tab" href="" role="tab"
              aria-selected="false">
              <span class="fa fa-2x fa-user-plus"></span>
              <span class="badge badge-pill badge-danger"></span>
              <br>
              Register
            </a>
          </li>
          <li class="nav-item col-md-2 col-sm-4 pl-0 pr-0" id="MenuProfile">
            <a class="nav-link user-menu bd-left-none" id="profile" data-toggle="tab" href="" role="tab"
              aria-selected="true">
              <span class="fa fa-2x fa-user"></span>
              <span class="badge badge-pill badge-danger"></span>
              <br>
              Profile
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->
</div>

<div class="barmaster" style="display: none;">
  <a class="nav-link navlink" data-widget="pushmenu" href="#" role="button" id='abar'><i
      class="fas fa-bars ibarmaster"></i></a>
</div>
<div class="manumaster" id="mumaster">
  <div id="divMenu" class="dmanu">
    <!-- <div class="groupmanu">
        <div class="headergroup">
          ข้อมูลหลัก
        </div>
        <div class="subgroup">
          ข้อมูลเลขที่ตำแหน่ง
        </div>
      </div> -->
  </div>
</div>
<div class="overmanu loadoverm" id="omanu">

</div>
<!-- ./wrapper -->
<!-- </div> -->


// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.html